export var breakpoints = {
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1440,
};
